import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import {
  Modal,
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Autocomplete,
  InputAdornment,
  Stack,
  Divider as MuiDivider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { IoClose, IoFlagOutline } from "react-icons/io5";
import { RxUpload } from "react-icons/rx";
import { Divider } from "antd";
import { getProject } from "../../services/project.service";
import {
  getProjectBasedUser,
  postTask,
  updateTask,
} from "../../services/taskManagement.service";
import { useNavigate } from "react-router-dom";
import ProjectSide_Icon from "../../assets/images/ProjectSide_Icon.svg";
import Bugs_Icon from "../../assets/images/bug.png";
import Task_Icon from "../../assets/images/Task_Icon.svg";
import Meeting_Icon from "../../assets/images/Meeting.png";
import Extra_Icon from "../../assets/images/Extra_Icon.svg";
import Testing_Icon from "../../assets/images/Testing_Icon.svg";
import Designing_Icon from "../../assets/images/Designing_Icon.svg";
import Deployment_Icon from "../../assets/images/Deployment_Icon.svg";
import { useAuth } from "../../context/AuthProvider";
import { jwtDecode } from "jwt-decode";
import { getTokenbyData } from "../../services/user.service";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FileUploader } from "react-drag-drop-files";
import { getProjectParentTask } from "../../services/parentTask";
import { getParentTask } from "../../services/parentTask";
import { PRIORITY, ISSUETYPE } from "../../common/constant/constant";

const AddTaskModal = (props) => {
  const {
    setOpenDrawer,
    formType,
    selectedData,
    GetData,
    open,
    onClose,
    fetchTasks,
    selectedRightValue,
    filteredStatus,
    defaultIssueType, // Add defaultIssueType prop
    preFilledData, // Add preFilledData prop
    isRelatedBug, // Add isRelatedBug prop to disable certain fields
  } = props;

  const { accessToken } = useAuth();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const disabled = formType === "view";
  const [projectData, setProjectData] = useState([]);
  const [projectParentData, setProjectParentData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [taskOption, setTaskOption] = useState([]);
  const [ParentTaskData, setParentTaskData] = useState([]);
  const [fileName, setFileName] = useState(
    formType === "edit" ? selectedData?.file?.fileName : 0
  );
  const [shouldCloseOnSave, setShouldCloseOnSave] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [initialValues, setInitialValues] = useState({
    issueType: defaultIssueType ?? null,
    title: preFilledData?.title || "",
    description: preFilledData?.description || "",
    project: preFilledData?.project?._id || preFilledData?.project || "",
    parentTask: preFilledData?.parentTask?._id || preFilledData?.parentTask || null,
    assignedBy: "",
    assignee: preFilledData?.assignee?._id || preFilledData?.assignee || "",
    priority: preFilledData?.priority || null,
    actualDeadlineDate: preFilledData?.actualDeadlineDate || "",
    estimatedTime: preFilledData?.estimatedTime || "",
    file: [],
    isclientView: false,
    relatedTask: preFilledData?.relatedTask || null,
  });
  const [meeting, setMeeting] = useState(selectedData?.taskType);

  // Debug: Log defaultIssueType and initial issueType
  console.log("AddTaskModal Props - defaultIssueType:", defaultIssueType);
  console.log("AddTaskModal Props - formType:", formType);
  console.log("Initial issueType value:", initialValues.issueType);

  const priorityOption = [
    {
      label: "Low",
      name: PRIORITY.LOW,
      icon: <IoFlagOutline size={16} color={"#21A600"} />,
    },
    {
      label: "Medium",
      name: PRIORITY.MEDIUM,
      icon: <IoFlagOutline size={16} color={"#D7BB21"} />,
    },
    {
      label: "High",
      name: PRIORITY.HIGH,
      icon: <IoFlagOutline size={16} color={"#D50707"} />,
    },
  ];

  const validationSchema = Yup.object().shape({
    // issueType: Yup.number()
    //   .typeError("Issue Type must be a number")
    //   .required("Issue Type is required"),

    title: Yup.string()
      .trim()
      .required("Title is required")
      .min(1, "Title cannot be empty"),

    project: Yup.string().required("Project is required"),

    parentTask: Yup.string().required("Parent Task is required"),

    priority: Yup.number()
      .typeError("Priority must be a number")
      .required("Priority is required"),

    assignee: Yup.string().required("Assignee is required"),

    estimatedTime: Yup.number()
      .typeError("Estimated Time must be a number")
      .positive("Estimated Time must be positive")
      .required("Estimated Time is required"),
  });

  const getUserIdFromToken = () => {
    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const GetProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const userId = getUserIdFromToken();

      // Get current user data to check if they are admin
      const userRes = await getTokenbyData();
      const userData = userRes?.data;
      const isAdmin = userData?.isOverAllAdmin || false;
      const isManager = userData?.isManager || false;

      let filteredProjects = res.data.data;

      // If user is not admin and not manager, filter projects
      // if (!isAdmin && !isManager && userId) {
      //   const allProjects = res.data.data;

      //   // Helper to check if user is lead on a specific project
      //   const checkIsLead = (project) => {
      //     return project.projectLead?.some((lead) => {
      //       const leadId = lead?._id || lead;
      //       return leadId?.toString() === userId?.toString();
      //     });
      //   };

      //   // Determine if user is a lead on ANY project
      //   const isProjectLeadRole = allProjects.some(checkIsLead);

      //   filteredProjects = allProjects.filter((project) => {
      //     const isLead = checkIsLead(project);

      //     // Check if user is assigned to the project
      //     const isAssigned = userData.project?.some((pId) => {
      //       const id = pId?._id || pId;
      //       return id?.toString() === project?._id?.toString();
      //     });

      //     if (isProjectLeadRole) {
      //       // If user is a lead somewhere, show ONLY projects they lead
      //       return isLead;
      //     } else {
      //       // If user is not a lead anywhere, show assigned projects
      //       return isAssigned;
      //     }
      //   });
      // }

      const configData = filteredProjects.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };
  const GetProjectParentData = async (projectId) => {
    try {
      const res = await getProjectParentTask(projectId, { isEnabled: true });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectParentData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   GetProjectParentData();
  // }, []);

  const GetProjectBasedUserData = async (selectedProjectId) => {
    try {
      console.log("selectedProjectId", selectedProjectId);
      if (selectedProjectId != undefined) {
        const res = await getProjectBasedUser(selectedProjectId);
        const Parenttask = await getProjectParentTask(selectedProjectId);
        const configData = res?.data?.data?.map((e) => {
          return {
            ...e,
            label: e.fullName,
          };
        });
        setParentTaskData(Parenttask?.data?.data);
        setEmployeeData(configData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    GetProjectData();
    if (formType === "edit" || formType === "view") {
      const files = selectedData?.file?.map((file) => file?.fileName) || [];
      setInitialValues({
        issueType: selectedData.issueType ?? null,
        title: selectedData.title || "",
        description: selectedData.description || "",
        parentTask: selectedData.parentTask || "",
        project: selectedData.project || "",
        priority:
          priorityOption.find(
            (o) =>
              o.label === selectedData.priority ||
              o.name === selectedData.priority
          )?.name ?? null,
        assignee: selectedData?.assignee || "",
        actualDeadlineDate: selectedData?.actualDeadlineDate || "",
        estimatedTime: selectedData?.estimatedTime || "",
        isclientView: selectedData?.isclientView || false,
      });
      setFileName(files.join(", "));
    } else if (preFilledData && Object.keys(preFilledData).length > 0) {
      console.log("Setting initial values from preFilledData:", preFilledData);
      // Set initial values when preFilledData is provided (e.g., from Add Bug button)
      setInitialValues((prev) => {
        const newValues = {
          ...prev,
          issueType: defaultIssueType,
          title: preFilledData.title !== undefined ? preFilledData.title : prev.title,
          description: preFilledData.description !== undefined ? preFilledData.description : prev.description,
          project: (preFilledData.project?._id || preFilledData.project) || prev.project,
          parentTask: (preFilledData.parentTask?._id || preFilledData.parentTask) || prev.parentTask,
          assignee: (preFilledData.assignee?._id || preFilledData.assignee) || prev.assignee,
          priority: preFilledData.priority !== undefined ? preFilledData.priority : prev.priority,
          actualDeadlineDate: preFilledData.actualDeadlineDate !== undefined ? preFilledData.actualDeadlineDate : prev.actualDeadlineDate,
          estimatedTime: preFilledData.estimatedTime !== undefined ? preFilledData.estimatedTime : prev.estimatedTime,
          relatedTask: preFilledData.relatedTask || prev.relatedTask,
        };
        console.log("New Initial Values Calculated:", newValues);
        return newValues;
      });
    } else {
      // Normal add mode - ensure issueType is set from defaultIssueType
      setInitialValues((prev) => ({
        ...prev,
        issueType: defaultIssueType ?? prev.issueType,
      }));
    }

    // Load project-based data if preFilledData has a project
    if (preFilledData?.project) {
      const projectId = preFilledData.project?._id || preFilledData.project;
      console.log("Fetching project data for project ID:", projectId);
      GetProjectBasedUserData(projectId);
    }
  }, [formType, selectedData, preFilledData, defaultIssueType]);

  const handleCancel = () => {
    navigate("/home/taskManagement", {
      state: {
        selectedRightValue: selectedRightValue,
        filteredStatus: filteredStatus,
      },
    });
  };

  const onSubmit = async (values, { resetForm }) => {
    setIsSaving(true);
    try {
      const formData = new FormData();
      const { files, ...bodyData } = values;
      const assignedBy = getUserIdFromToken();

      // Append files if they exist
      if (files && files.length) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      const filteredBodyData = { ...bodyData, assignedBy, status: 0 };

      // Append the body data
      formData.append("bodyData", JSON.stringify(filteredBodyData));

      // Determine whether to create or update
      const apiMethod =
        formType === "edit"
          ? updateTask(selectedData._id, formData)
          : postTask(formData);

      // Execute the API call
      const res = await apiMethod;
      if (res.error === false) {
        ToastSuccess(res.data.message);
        fetchTasks();
        if (shouldCloseOnSave) {
          onClose();
        } else {
          // Reset form fields if Save (not Save and Exit)
          resetForm();
        }
      }
    } catch (error) {
      ToastError(error?.data?.message);
    } finally {
      setIsSaving(false);
    }
  };
  const truncateTitle = (title, maxWords = 4) => {
    if (!title) return "";
    const words = title.split(" ");
    if (words.length <= maxWords) return title;
    return words.slice(0, maxWords).join(" ") + "...";
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "80%", md: "72%" },
          height: "auto",
          bgcolor: "background.paper",
          maxHeight: "92vh",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          overflowY: "auto",
        }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          innerRef={formRef}
        >
          {({ touched, errors, values, setFieldValue }) => (
            <Form>
              <Stack
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant="h6">
                  {formType === "edit"
                    ? "Edit"
                    : formType === "view"
                      ? "View"
                      : "Add"}{" "}
                  Task
                </Typography>
                <Box sx={{ cursor: "pointer" }} onClick={onClose}>
                  <IoClose size={24} />
                </Box>
              </Stack>
              <MuiDivider sx={{ opacity: 1, my: 1 }} />
              <Stack spacing={1.8} mt={1.5}>
                {/* Row 1: Project, Parent Task, Assignee */}
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <FormControl fullWidth>
                    <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                      Project *
                    </Typography>
                    <Autocomplete
                      options={projectData}
                      value={
                        projectData.find(
                          (option) => option._id === values.project
                        ) || null
                      }
                      onChange={(e, v) => {
                        setFieldValue("project", v?._id);
                        GetProjectBasedUserData(v?._id);
                      }}
                      disabled={isRelatedBug || disabled}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project"
                          error={touched.project && Boolean(errors.project)}
                          helperText={touched.project && errors.project}
                          InputProps={{
                            ...params.InputProps,
                          }}
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl fullWidth>
                    <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                      Parent Task *
                    </Typography>
                    <Autocomplete
                      options={ParentTaskData}
                      value={
                        ParentTaskData.find(
                          (option) => option._id === values.parentTask
                        ) || null
                      }
                      getOptionLabel={(option) => {
                        const projectTypeName = option.projectType?.name
                          ? ` (${option.projectType.name})`
                          : "";
                        return option?.title
                          ? `${option.code} - ${truncateTitle(
                            option.title
                          )}${projectTypeName}`
                          : option.code || "";
                      }}
                      onChange={(e, v) => {
                        setFieldValue("parentTask", v?._id);
                      }}
                      disabled={isRelatedBug || disabled}
                      renderOption={(props, option) => {
                        const projectTypeName = option.projectType?.name
                          ? ` (${option.projectType.name})`
                          : "";
                        return (
                          <li {...props}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  marginRight: "8px",
                                  flex: 1,
                                }}
                              >
                                {option.code} - {option.title}
                              </span>
                              <span
                                style={{
                                  whiteSpace: "nowrap",
                                  fontSize: "0.85em",
                                  color: "text.secondary",
                                  fontWeight: "500",
                                }}
                              >
                                {projectTypeName}
                              </span>
                            </div>
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Parent Task"
                          error={
                            touched.parentTask && Boolean(errors.parentTask)
                          }
                          helperText={touched.parentTask && errors.parentTask}
                          InputProps={{
                            ...params.InputProps,
                          }}
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl fullWidth>
                    <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                      Assignee *
                    </Typography>
                    <Autocomplete
                      options={employeeData}
                      value={
                        employeeData.find(
                          (option) => option._id === values.assignee
                        ) || null
                      }
                      onChange={(e, v) => {
                        setFieldValue("assignee", v?._id);
                      }}
                      disabled={disabled}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Assignee"
                          error={
                            touched.assignee && Boolean(errors.assignee)
                          }
                          helperText={touched.assignee && errors.assignee}
                        />
                      )}
                    />
                  </FormControl>
                </Stack>

                {meeting === "Meeting" ? (
                  <>
                    <FormControl fullWidth>
                      <Typography variant="body1" sx={{ mb: 0.5 }}>
                        Title
                      </Typography>
                      <Field
                        name="title"
                        as={TextField}
                        fullWidth
                        placeholder="Enter Title"
                        disabled={disabled}
                        error={touched.title && Boolean(errors.title)}
                        helperText={touched.title && errors.title}
                      />
                    </FormControl>

                    <FormControl fullWidth>
                      <Typography variant="body1" sx={{ mb: 0.5 }}>
                        Description
                      </Typography>
                      <Field
                        name="description"
                        as={TextField}
                        fullWidth
                        placeholder="Enter Description"
                        disabled={disabled}
                        error={
                          touched.description && Boolean(errors.description)
                        }
                        helperText={touched.description && errors.description}
                      />
                    </FormControl>

                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                      <FormControl fullWidth>
                        <Typography variant="body1" sx={{ mb: 0.5 }}>
                          Start Time
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            className="datePicker w-100"
                            value={
                              values?.startDate
                                ? dayjs(values?.startDate)
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue("startDate", value)
                            }
                            format="HH:mm"
                          />
                        </LocalizationProvider>
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="body1" sx={{ mb: 0.5 }}>
                          End Time
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            className="datePicker w-100"
                            value={
                              values?.endDate ? dayjs(values?.endDate) : null
                            }
                            onChange={(value) =>
                              setFieldValue("endDate", value)
                            }
                            format="HH:mm"
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Stack>
                  </>
                ) : (
                  <>
                    {/* Row 2: Priority, Deadline Date, Estimate Time */}
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                      <FormControl fullWidth>
                        <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                          Priority *
                        </Typography>
                        <Autocomplete
                          options={priorityOption}
                          value={
                            priorityOption.find(
                              (option) => option.name === values.priority
                            ) || null
                          }
                          onChange={(e, v) => {
                            setFieldValue("priority", v?.name);
                          }}
                          disabled={isRelatedBug || disabled}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <span
                                style={{
                                  marginRight: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {option.icon}
                              </span>
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Priority"
                              error={
                                touched.priority && Boolean(errors.priority)
                              }
                              helperText={touched.priority && errors.priority}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: values.priority ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "8px",
                                    }}
                                  >
                                    {
                                      priorityOption.find(
                                        (option) =>
                                          option.name === values.priority
                                      )?.icon
                                    }
                                  </div>
                                ) : null,
                              }}
                            />
                          )}
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                          Deadline Date
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={
                              values?.actualDeadlineDate
                                ? dayjs(values?.actualDeadlineDate)
                                : null
                            }
                            onChange={(date) =>
                              setFieldValue(
                                "actualDeadlineDate",
                                dayjs(date).utc(true).toISOString()
                              )
                            }
                            className="datePicker w-100"
                            disabled={disabled}
                            format="DD/MM/YYYY"
                            minDate={dayjs()}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                            slotProps={{
                              textField: {
                                error:
                                  touched.actualDeadlineDate &&
                                  Boolean(errors.actualDeadlineDate),
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                          Estimate Time *
                        </Typography>
                        <Field
                          name="estimatedTime"
                          as={TextField}
                          type="number"
                          fullWidth
                          placeholder="Hours"
                          disabled={disabled}
                          error={
                            touched.estimatedTime && Boolean(errors.estimatedTime)
                          }
                          helperText={
                            touched.estimatedTime && errors.estimatedTime
                          }
                        />
                      </FormControl>
                    </Stack>

                    {/* Row 3: Title (2/3) + Upload Image (1/3) */}
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                      <Box sx={{ flex: 2 }}>
                        <FormControl fullWidth>
                          <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                            Title *
                          </Typography>
                          <Field
                            name="title"
                            as={TextField}
                            fullWidth
                            placeholder="Enter Title"
                            disabled={disabled}
                            error={touched.title && Boolean(errors.title)}
                            helperText={touched.title && errors.title}
                          />
                        </FormControl>
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth>
                          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                              Upload Image
                            </Typography>
                            {fileName?.length > 0 && (
                              <IoClose
                                onClick={() => {
                                  setFileName("");
                                  setFieldValue("files", []);
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                }}
                              />
                            )}
                          </Stack>
                          <FileUploader
                            handleChange={(e) => {
                              const files =
                                e instanceof FileList ? Array.from(e) : [e];
                              setFieldValue("files", files);
                              setFileName(
                                files.map((file) => file.name).join(", ")
                              );
                            }}
                            name="files"
                            multiple={true}
                            dropMessageStyle={{
                              color: "green",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            <Stack
                              sx={{
                                border: "2px dashed #B9BDC4",
                                padding: "8px",
                                borderRadius: "6px",
                                textAlign: "center",
                              }}
                            >
                              <Stack
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={0.5}
                              >
                                <RxUpload color="#008080" size={14} />
                                <Typography
                                  variant="body1"
                                  sx={{ fontSize: "11px", fontWeight: "500" }}
                                >
                                  {fileName ? (
                                    fileName
                                  ) : (
                                    <>
                                      <span style={{ color: "#008080" }}>
                                        Choose file
                                      </span>
                                    </>
                                  )}
                                </Typography>
                              </Stack>
                            </Stack>
                          </FileUploader>
                        </FormControl>
                      </Box>
                    </Stack>

                    {/* Row 4: Description (full width) */}
                    <FormControl fullWidth>
                      <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                        Description
                      </Typography>
                      <Field
                        name="description"
                        render={({ field, form }) => (
                          <ReactQuill
                            value={field.value || ""}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                            placeholder="Enter Description"
                            style={{
                              borderRadius: "8px",
                              height: "80px",
                              marginBottom: "30px",
                            }}
                            disabled={disabled}
                            modules={{
                              toolbar: [
                                [
                                  { header: "1" },
                                  { header: "2" },
                                  { font: [] },
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["bold", "italic", "underline"],
                                [{ align: [] }],
                              ],
                            }}
                          />
                        )}
                      />
                      {touched.description && errors.description && (
                        <Typography color="error" variant="caption">
                          {errors.description}
                        </Typography>
                      )}
                    </FormControl>
                  </>
                )}

                <MuiDivider />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column-reverse", sm: "row" },
                    justifyContent: "space-between",
                    gap: 2,
                    mt: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <FormControlLabel
                      label="Client View"
                      control={
                        <Field
                          type="checkbox"
                          name="isclientView"
                          as={Checkbox}
                          disabled={disabled}
                          sx={{
                            color: "#008080",
                            "&.Mui-checked": {
                              color: "#008080",
                            },
                          }}
                        />
                      }
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Button
                      onClick={onClose}
                      variant="outlined"
                      sx={{
                        borderColor: "#008080",
                        color: "#008080",
                        fontSize: "14px",
                        width: { xs: "100%", sm: "auto" },
                        "&:hover": {
                          backgroundColor: "white",
                          color: "#008080",
                        },
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      onClick={() => {
                        setShouldCloseOnSave(false);
                        formRef.current.handleSubmit();
                      }}
                      variant="contained"
                      disabled={isSaving || disabled}
                      sx={{
                        backgroundColor: "#008080",
                        color: "white",
                        fontSize: "14px",
                        width: { xs: "100%", sm: "auto" },
                        "&:hover": {
                          backgroundColor: "#006666",
                        },
                        display: disabled ? "none" : "flex",
                      }}
                    >
                      {isSaving && !shouldCloseOnSave ? "Saving..." : "Save"}
                    </Button>
                    <Button
                      onClick={() => {
                        setShouldCloseOnSave(true);
                        formRef.current.handleSubmit();
                      }}
                      variant="contained"
                      disabled={isSaving || disabled}
                      sx={{
                        backgroundColor: "#008080",
                        color: "white",
                        fontSize: "14px",
                        width: { xs: "100%", sm: "auto" },
                        "&:hover": {
                          backgroundColor: "#006666",
                        },
                        display: disabled ? "none" : "flex",
                      }}
                    >
                      {isSaving && shouldCloseOnSave
                        ? "Saving..."
                        : "Save and Exit"}
                    </Button>
                  </Box>
                </Box>
              </Stack>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AddTaskModal;
